"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.revokeAuthNTokens = exports.exchangeAuthNTokens = void 0;
const constant_1 = require("../constant");
const createUrlSearchParams_1 = require("./createUrlSearchParams");
const cognitoHostedUIEndpoints_1 = require("./cognitoHostedUIEndpoints");
const exchangeAuthNTokens = async ({ redirectUri, userPoolClientId, oAuthConfig, code, codeVerifier, }) => {
    const searchParams = (0, createUrlSearchParams_1.createUrlSearchParamsForTokenExchange)({
        client_id: userPoolClientId,
        code,
        redirect_uri: redirectUri,
        code_verifier: codeVerifier,
        grant_type: constant_1.OAUTH_GRANT_TYPE,
    });
    const oAuthTokenEndpoint = (0, cognitoHostedUIEndpoints_1.createTokenEndpoint)(oAuthConfig.domain);
    const tokenExchangeResponse = await fetch(oAuthTokenEndpoint, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cache-Control': 'no-cache',
        },
        body: searchParams.toString(),
    });
    // Exchanging an authorization code grant with PKCE for tokens with
    // `grant_type=authorization_code` produces a stable shape of payload.
    // Details see https://docs.aws.amazon.com/cognito/latest/developerguide/token-endpoint.html
    // Possible errors: invalid_request|invalid_client|invalid_grant|unauthorized_client|unsupported_grant_type
    // Should not happen unless configuration is wrong;
    return (await tokenExchangeResponse.json());
};
exports.exchangeAuthNTokens = exchangeAuthNTokens;
const revokeAuthNTokens = async ({ userPoolClientId, refreshToken, endpointDomain, }) => {
    const searchParams = (0, createUrlSearchParams_1.createUrlSearchParamsForTokenRevocation)({
        client_id: userPoolClientId,
        token: refreshToken,
    });
    const oAuthTokenRevocationEndpoint = (0, cognitoHostedUIEndpoints_1.createRevokeEndpoint)(endpointDomain);
    const response = await fetch(oAuthTokenRevocationEndpoint, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cache-Control': 'no-cache',
        },
        body: searchParams.toString(),
    });
    const contentLength = parseInt(response.headers.get('Content-Length') ?? '0', 10);
    return contentLength === 0
        ? {}
        : (await response.json());
};
exports.revokeAuthNTokens = revokeAuthNTokens;
